// utils/tokenStorage.js
export const getTokenStorage = () => {
  // Check if we're on Safari/iOS
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  if (isIOS || isSafari) {
    // console.log("Using localStorage for token storage (Safari/iOS detected)");
    return "localStorage";
  }

  // For other browsers, try cookies first, fallback to localStorage
  try {
    // Test if cookies are accessible
    document.cookie = "testCookie=1; SameSite=None; Secure";
    const cookiesEnabled = document.cookie.indexOf("testCookie") !== -1;
    document.cookie = "testCookie=1; expires=Thu, 01 Jan 1970 00:00:00 GMT";

    return cookiesEnabled ? "cookie" : "localStorage";
  } catch (error) {
    // console.log("Cookies not accessible, using localStorage");
    return "localStorage";
  }
};

export const setToken = (key, value) => {
  const storageType = getTokenStorage();

  if (storageType === "cookie") {
    // Set cookie with 7 days expiry
    const expires = new Date();
    expires.setDate(expires.getDate() + 7);
    document.cookie = `${key}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=None; Secure`;
  } else {
    localStorage.setItem(key, value);
  }
};

export const getToken = (key) => {
  const storageType = getTokenStorage();

  if (storageType === "cookie") {
    const name = key + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  } else {
    return localStorage.getItem(key);
  }
};

export const removeToken = (key) => {
  const storageType = getTokenStorage();

  if (storageType === "cookie") {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  } else {
    localStorage.removeItem(key);
  }
};
